export default "__VITE_ASSET__1idmGysv__"